import { gql } from '@grandvisionhq/graphql';
import { eyePrescription } from '../eye-prescription.js';

const prescriptionGlassesTypeDetails = gql`
  fragment PrescriptionGlassesTypeDetailsFragment on BundlePrescriptionGlassesTypeDetails {
    newPrescription {
      leftLens {
        ...EyePrescriptionFragment
      }
      rightLens {
        ...EyePrescriptionFragment
      }
      opticianDetails {
        type
        opticianName
        postalCode
        city
        country
        address
        streetName
        additionalStreetInfo
        additionalAddressInfo
        region
      }
      expiryDate
    }
    prescriptionFile {
      fileName
      storageId
      __typename
    }
    pupillaryDistanceFile {
      fileName
      storageId
      __typename
    }
    isEmailPrescription
    isExistingCustomer
  }
  ${eyePrescription}
`;

export { prescriptionGlassesTypeDetails };
//# sourceMappingURL=prescription-glasses.js.map
